module.exports = {
    RECORD_DELIMITER : 0x01,
    FIELD_DELIMITER : 0x02,
    EMPTY_FIELD : 0x03,
    RECORD_MU : 0x04,
    FIELD_MU : 0x05
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/content/consts.js
// module id = 293
// module chunks = 0